// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../../../_abstract/adapter';
import { RelatedType } from '../../../../services';
import { ModuleDriver } from '../../../_contracts';
import { getModuleBase } from '../../../_helpers/adapter';
import { EmbedVersion } from '../../Embed.contracts';
export class EmbedPdfAdapter extends AbstractAdapter {
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            pdf: {
                presence: true,
                type: 'object'
            },
            'pdf.type': getRelatedTypeConstraint(RelatedType.File, true),
            'pdf.value': getIdentifierConstraint(true)
        });
        const { description, pdf, pdfAsLink } = content;
        if (!pdf) {
            throw new Error('[pdf.value] is required, but none was provided');
        }
        const meta = {
            id: pdf.value,
            description: description
        };
        const raw = `#PDF[ id: ${pdf.value} | description: ${description}]`;
        return {
            content: String(pdf.value),
            raw,
            meta,
            type: TokenType.EmbedPdf
        };
    }
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                id: {
                    type: 'number'
                },
                description: {
                    type: 'string'
                }
            });
        }
        const { content, meta } = token;
        const object = {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Embed,
            version: EmbedVersion.PDF
        };
        if (typeof content === 'string') {
            object.content.pdf = {
                type: RelatedType.File,
                value: Number(content)
            };
        }
        if (typeof meta !== 'undefined') {
            const { description } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            else {
                object.content.description = '';
            }
        }
        object.content.type = EmbedVersion.PDF;
        return object;
    }
}
